import { FileModel } from "./model/FileModel";
import { post } from "../api";

export const uploadFile = async (file: File, previewFile?: File | null): Promise<FileModel> => {
    const formData = new FormData();

    formData.append(`file`, file as Blob);

    if (previewFile) {
        formData.append(`preview_file`, previewFile as Blob);
    }

    return await post({ url: `/admin/files`, body: formData });
};
